import React from 'react';
import ModuleOrderLink from 'components/billing/ModuleOrderLink';
import ModulePriceBox from 'components/billing/ModulePriceBox';
import '../../../style/scss/billing.scss';

interface ModuleOrderCardProps {
    feature: string;
    title: string;
    description?: string;
    priceType?: string;
    flatPrice?: string;
    pricePerSeat?: string;
    frameless?: boolean;
    showOrderLink?: boolean;
    onOrdered?: () => void;
};

// Wide card promoting an orderable module with its price and order link
const ModuleOrderCard: React.FC<ModuleOrderCardProps> = ({
    feature, title, description, priceType, flatPrice, pricePerSeat, frameless, showOrderLink = true, onOrdered
}) => {
    return (
        <div className={`${frameless ? '' : 'pageheader module-card'} module-order-card`}>
            <div className='module-order-card-content'>
                <h5>{title}</h5>
                {description && (
                    <p className='explanation-text'>{description}</p>
                )}
                {showOrderLink && (
                    <ModuleOrderLink feature={feature} onOrdered={onOrdered} />
                )}
            </div>
            {priceType && (
                <ModulePriceBox priceType={priceType} flatPrice={flatPrice} pricePerSeat={pricePerSeat} />
            )}
        </div>
    );
};

export default ModuleOrderCard;
